// extracted by mini-css-extract-plugin
export var addButton = "_on-0";
export var border = "_on-8";
export var check = "_on-h";
export var danger = "_on-6";
export var dropdownContainer = "_on-1";
export var editModalBody = "_on-j";
export var footerContainer = "_on-i";
export var fullWidth = "_on-a";
export var hide = "_on-9";
export var icon = "_on-3";
export var input = "_on-7";
export var inputFlex = "_on-b";
export var inputWrapper = "_on-c";
export var manualFocus = "_on-5";
export var optionButton = "_on-4";
export var pillWrapper = "_on-e";
export var pointer = "_on-2";
export var showOverflow = "_on-f";
export var tagsFlex = "_on-d";
export var xButton = "_on-g";